import React, { Fragment, useState } from "react";
import {
  Collapse,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
  Badge,
} from "@mui/material";
import Rabbit from "rabbit-node/lib/rabbit";

import { useNavigate } from 'react-router'; // Import the useNavigate hook to Navigate

import { ExpandMore, ExpandLess } from "@mui/icons-material"; // Import the icons

/*** Api Get All Publishers ***/
import { useFetchAudioAllPublisherDataQuery } from "../../../api/audioAllPublisherPageApi";

/*** HELPER FUNCTIONS ***/
import { englishToMyanmarNumber } from "../../../helpers/EngNumberToMyanmar";

import { NotFound } from "../../error/NotFound_404";

const Index = () => {
    const navigate = useNavigate();

  const [openIndex, setOpenIndex] = useState(null);

  const handleListItemClick = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const handleClickAuthor = (author) => {
    navigate(`/audio/books-by-author/${author.idx}`);
  };

  const { data, error, isLoading, isFetching } =
    useFetchAudioAllPublisherDataQuery();

  if (isLoading) {
    return (
      <>
        <h1>Loading</h1>
      </>
    );
  }

  if (error) {
    return <NotFound error={error} />
  }

  return (
    <List>
      {data.data.map((group, index) => (
        <React.Fragment key={group.gid}>
          <ListItem
            button
            onClick={() => handleListItemClick(index)}
            className="rounded-lg bg-slate-500"
          >
             <ListItemIcon sx={{ color: "#52525b" }}>
              {openIndex === index ? <ExpandMore /> : <ExpandLess />}
            </ListItemIcon>
            <ListItemText
              className={openIndex === index ? "text-yellow-300" : ""}
              primary={group.gid}
            />
          </ListItem>
          <Collapse in={openIndex === index} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {group.authors.map((author) => (
                <Fragment key={author.idx}>
                  <div style={{ display: "flex", alignItems: "center" }} onClick={() => handleClickAuthor(author)}>
                    <ListItem className="inline">
                      <ListItemText primary={Rabbit.zg2uni(author.name)} />
                    </ListItem>
                    <div style={{ marginLeft: "auto" }}>
                      <Badge
                        color="secondary"
                        overlap="circular"
                        className="mr-4"
                      >
                        <div
                          style={{
                            width: 30,
                            height: 30,
                            borderRadius: "50%",
                            background: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "black",
                          }}
                          className="text-xs"
                        >
                          {englishToMyanmarNumber(author.book_count)}
                        </div>
                      </Badge>
                    </div>
                  </div>
                  <Divider
                    variant="middle"
                    sx={{ backgroundColor: "#52525b" }}
                  />
                </Fragment>
              ))}
            </List>
          </Collapse>
          <Divider variant="middle" sx={{ backgroundColor: "#52525b" }} />
        </React.Fragment>
      ))}
    </List>
  );
};

export default Index;
